import { eqArrays } from "../../shared/utils";

export function multiselectV2(args) {
  const { label, includeSearch, options, onChange, onToggle } = args;

  const allRootIds = new Set(options.map((o) => o.id));
  const selectedIds = new Set(
    args.selectedIds.filter((id) => allRootIds.has(id)),
  );

  let _valueAtOpen;

  const ITEM_HEIGHT = 32; // Height of each item in pixels

  return {
    searchResults: [],
    selectedIds,
    includeSearch,
    label,
    expanded: false,
    scrollTop: 0,
    containerHeight: 0,
    visibleItems: [],
    get selectedIdsArr() {
      return Array.from(this.selectedIds);
    },
    get totalHeight() {
      return this.searchResults.length * ITEM_HEIGHT;
    },
    focus() {
      this.searchResults = options;
      this.updateVisibleItems();

      this.expanded = true;

      this.$nextTick(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus();
        if (this.$refs.scrollContainer) {
          this.containerHeight = this.$refs.scrollContainer.clientHeight;
          this.updateVisibleItems();
        }
      });

      _valueAtOpen = this.selectedIdsArr;
    },
    toggleDropdown() {
      if (this.expanded) {
        return this.unfocus();
      }

      this.focus();
    },
    unfocus() {
      if (!this.expanded) return;

      this.expanded = false;

      const valueNow = this.selectedIdsArr;
      const changed = !eqArrays(_valueAtOpen, valueNow);

      this.$nextTick(() => {
        if (changed) {
          onChange(this.$root, Array.from(valueNow));
        }

        if (this.$refs.searchInput) {
          this.$refs.searchInput.value = "";
          this.$refs.searchInput.blur();
        }
      });
    },
    isSelected(id) {
      return this.selectedIds.has(id);
    },
    toggleSelectTag(id) {
      if (this.isSelected(id)) {
        this.selectedIds.delete(id);
      } else {
        this.selectedIds.add(id);
      }

      onToggle(this.$root, Array.from(this.selectedIds));
    },
    deselectAll() {
      this.selectedIds.clear();

      onChange(this.$root, Array.from(this.selectedIds));

      this.expanded = false;
    },
    search() {
      const searchTerm = this.$refs.searchInput.value;

      if (searchTerm.length > 0) {
        let tag_group_name = "";
        const matchingResult = options.reverse().filter((option) => {
          const isNonTagGroupNameMatch =
            option.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
            !option.is_group_label;
          const isTagGroupOfMatch =
            option.is_group_label && option.name === tag_group_name;

          if (isNonTagGroupNameMatch || isTagGroupOfMatch) {
            tag_group_name = option.tag_group_name;
            return true;
          } else {
            return false;
          }
        });
        options.reverse();
        this.searchResults = matchingResult.reverse();
      } else {
        this.searchResults = options;
      }

      // Reset scroll and update visible items
      this.scrollTop = 0;
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTop = 0;
      }
      this.updateVisibleItems();
    },
    handleScroll(event) {
      this.scrollTop = event.target.scrollTop;
      this.updateVisibleItems();
    },
    updateVisibleItems() {
      if (!this.containerHeight) {
        // Initial render - show first 50 items
        this.visibleItems = this.searchResults
          .slice(0, 50)
          .map((item, index) => ({
            ...item,
            virtualIndex: index,
            style: `transform: translateY(${index * ITEM_HEIGHT}px); height: ${ITEM_HEIGHT}px;`,
          }));
        return;
      }

      const startIndex = Math.floor(this.scrollTop / ITEM_HEIGHT);
      const endIndex = Math.min(
        startIndex + Math.ceil(this.containerHeight / ITEM_HEIGHT) + 1,
        this.searchResults.length,
      );

      this.visibleItems = this.searchResults
        .slice(startIndex, endIndex)
        .map((item, index) => ({
          ...item,
          virtualIndex: startIndex + index,
          style: `transform: translateY(${(startIndex + index) * ITEM_HEIGHT}px); height: ${ITEM_HEIGHT}px;`,
        }));
    },
  };
}
